import { Location } from 'react-router-dom';
import API from '../API';

export const getStats = async (location: Location) => {
	const stats = await API.stats.panel();

	if (location.state?.stats) {
		location.state.stats = stats;
	}

	return stats;
};
